export default {
  init() {
    // console.log("home");
  },
  finalize() {
    // console.log("home finalize");
  }
};
